/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { projectSettingsServicedeskLiveChatRoute } from '@jira/router-routes__project-settings-service-desk-live-chat-routes/src/projectSettingsServicedeskLiveChatRoute.tsx';
import { projectSettingsServicedeskPoliciesRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskPoliciesRoute.tsx';
import { projectSettingsServicedeskAutomationRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskAutomationRoute.tsx';
import { projectSettingsServicedeskNotificationsEmailRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsEmailRoute.tsx';
import { projectSettingsServicedeskNotificationsNotificationEmailRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsNotificationEmailRoute.tsx';
import { projectSettingsServicedeskAutomationSummaryRoute } from '@jira/router-routes__project-settings-service-desk-automation-routes/src/projectSettingsServicedeskAutomationSummaryRoute.tsx';
import { projectSettingsServicedeskAccessRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskAccessRoute.tsx';
import { projectSettingsServicedeskAppsFieldsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskAppsFieldsRoute.tsx';
import { projectSettingsServicedeskChangeManagementRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChangeManagementRoute.tsx';
import { projectSettingsServicedeskChannelsChatRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChannelsChatRoute.tsx';
import { projectSettingsServicedeskChannelsPermissionsNextGenRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChannelsPermissionsNextGenRoute.tsx';
import { projectSettingsServicedeskChannelsPortalRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChannelsPortalRoute.tsx';
import { projectSettingsServicedeskChannelsWidgetRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChannelsWidgetRoute.tsx';
import { projectSettingsServicedeskChatRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChatRoute.tsx';
import { projectSettingsServicedeskCustomerPermissionsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskCustomerPermissionsRoute.tsx';
import { projectSettingsServicedeskEmailRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskEmailRoute.tsx';
import { projectSettingsServicedeskExternalLinksRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskExternalLinksRoute.tsx';
import { projectSettingsServicedeskFeedbackRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskFeedbackRoute.tsx';
import { projectSettingsServicedeskFieldsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskFieldsRoute.tsx';
import { projectSettingsServicedeskIncidentManagementRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIncidentManagementRoute.tsx';
import { servicedeskQueuesManageViewRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskQueuesManageViewRoute.tsx';
import { servicedeskPracticeManageViewRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskPracticeManageViewRoute.tsx';
import { projectSettingsServicedeskInternalNotificationsNextGenRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskInternalNotificationsNextGenRoute.tsx';
import { projectSettingsServicedeskIssuetypesRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIssuetypesRoute.tsx';
import { projectSettingsServicedeskNotificationsInternalNotificationsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsInternalNotificationsRoute.tsx';
import { projectSettingsServicedeskPortalSettingsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskPortalSettingsRoute.tsx';
import { projectSettingsServicedeskProformaProjectFormsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskProformaProjectFormsRoute.tsx';
import { projectSettingsServicedeskItsmTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskItsmTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskWidgetRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskWidgetRoute.tsx';
import { virtualAgentSettingsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/virtualAgentSettingsRoute.tsx';
import { landingPageRoute } from '@jira/router-routes__project-settings-service-desk-virtual-agent-routes/src/landingPageRoute.tsx';
import { browseConversationsRoute } from '@jira/router-routes__project-settings-service-desk-virtual-agent-routes/src/browseConversationsRoute.tsx';
import { browseIntentsRoute } from '@jira/router-routes__project-settings-service-desk-virtual-agent-routes/src/browseIntentsRoute.tsx';
import { browseStandardFlowsRoute } from '@jira/router-routes__project-settings-service-desk-virtual-agent-routes/src/browseStandardFlowsRoute.tsx';
import { projectSettingServicedeskRovoServiceRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskRovoServiceRoute.tsx';
import { projectSettingsServicedeskAiAgentsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskAiAgentsRoute.tsx';
import { projectSettingServicedeskRequestResolverRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskRequestResolverRoute.tsx';
import { projectSettingServicedeskSelfServiceSetupRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskSelfServiceSetupRoute.tsx';
import { projectSettingsServicedeskCustomerNotificationsRoute } from '@jira/router-routes__project-settings-service-desk-customer-notifications-routes/src/projectSettingsServicedeskCustomerNotificationsRoute.tsx';
import { projectSettingsServicedeskNotificationsCustomerNotificationsRoute } from '@jira/router-routes__project-settings-service-desk-customer-notifications-routes/src/projectSettingsServicedeskNotificationsCustomerNotificationsRoute.tsx';
import { projectSettingsServicedeskCaseNotesEditRoute } from '@jira/router-routes__project-settings-service-desk-case-management-routes/src/projectSettingsServicedeskCaseNotesEditRoute.tsx';
import { projectSettingsServicedeskCaseNotesRoute } from '@jira/router-routes__project-settings-service-desk-case-management-routes/src/projectSettingsServicedeskCaseNotesRoute.tsx';
import { projectSettingsServicedeskKbRoute } from '@jira/router-routes__project-settings-service-desk-knowledge-base-routes/src/projectSettingsServicedeskKbRoute.tsx';
import { servicedeskSlaSettingsRoute } from '@jira/router-routes__project-settings-service-desk-sla-settings-routes/src/servicedeskSlaSettingsRoute.tsx';
import { projectSettingsServicedeskWorkforceRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskWorkforceRoute.tsx';
import { projectSettingsServicedeskWorkforceOptimizationRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskWorkforceOptimizationRoute.tsx';
import { projectSettingsServicedeskTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskUnassignedTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskUnassignedTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskProactiveSupportRoute } from '@jira/router-routes__project-settings-service-desk-proactive-support-routes/src/projectSettingsServicedeskProactiveSupportRoute.tsx';
import { projectSettingsServicedeskProactiveSupportSensorDetailsRoute } from '@jira/router-routes__project-settings-service-desk-proactive-support-routes/src/projectSettingsServicedeskProactiveSupportSensorDetailsRoute.tsx';
import { servicedeskWorkflowConfigRoute } from '@jira/router-routes__project-settings-workflow-scheme-config-routes/src/servicedeskWorkflowConfigRoute.tsx';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import {
	MENU_ID_SD_SETTINGS_ACCESS,
	MENU_ID_SD_SETTINGS_APPS,
	MENU_ID_SD_SETTINGS_AUTOMATION,
	MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE,
	MENU_ID_SD_SETTINGS_NOTIFICATIONS,
	MENU_ID_SD_SETTINGS_OPERATIONS,
	MENU_ID_SD_SETTINGS_QUEUES,
	MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT,
	MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES,
	MENU_ID_SD_SETTINGS_WORKFORCE_OPTIMIZATION,
} from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>([
	'legacy-project-settings-fields',
	'legacy-project-settings-issue-security',
	'legacy-project-settings-issue-types',
	'legacy-project-settings-notifications',
	'legacy-project-settings-people',
	'legacy-project-settings-permissions',
	'legacy-project-settings-screens',
	'legacy-project-settings-workflows',
	'legacy-project-settings-workflows-associate',
	'project-settings-automation',
	'project-settings-servicedesk-rovo-ops',
	'project-settings-servicedesk-rovo',
	projectSettingsServicedeskAiAgentsRoute.name,
	projectSettingsServicedeskWorkforceRoute.name,
	projectSettingsServicedeskWorkforceOptimizationRoute.name,
	'project-settings-servicedesk-employee-onboarding-configuration',
	'project-setting-servicedesk-rovo-service',
	projectSettingServicedeskRequestResolverRoute.name,
	'project-setting-servicedesk-self-service-setup',
	'servicedesk-sla-settings',
	projectSettingsServicedeskAutomationSummaryRoute.name,
	projectSettingsServicedeskAccessRoute.name,
	projectSettingsServicedeskChannelsPermissionsNextGenRoute.name,
	projectSettingsServicedeskCustomerPermissionsRoute.name,
	projectSettingsServicedeskFeedbackRoute.name,
	projectSettingsServicedeskFieldsRoute.name,
	projectSettingsServicedeskPoliciesRoute.name,
	projectSettingsServicedeskProformaProjectFormsRoute.name,
	projectSettingsServicedeskItsmTicketTypesConfigRoute.name,
	projectSettingsServicedeskChatRoute.name,
	projectSettingsServicedeskEmailRoute.name,
	projectSettingsServicedeskExternalLinksRoute.name,
	projectSettingsServicedeskPortalSettingsRoute.name,
	projectSettingsServicedeskWidgetRoute.name,
	projectSettingsServicedeskChangeManagementRoute.name,
	projectSettingsServicedeskIncidentManagementRoute.name,
	projectSettingsServicedeskChannelsChatRoute.name,
	projectSettingsServicedeskChannelsWidgetRoute.name,
	projectSettingsServicedeskNotificationsEmailRoute.name,
	projectSettingsServicedeskNotificationsNotificationEmailRoute.name,
	projectSettingsServicedeskNotificationsInternalNotificationsRoute.name,
	projectSettingsServicedeskAppsFieldsRoute.name,
	projectSettingsServicedeskCustomerNotificationsRoute.name,
	projectSettingsServicedeskNotificationsCustomerNotificationsRoute.name,
	projectSettingsServicedeskCaseNotesEditRoute.name,
	projectSettingsServicedeskCaseNotesRoute.name,
	projectSettingsServicedeskKbRoute.name,
	projectSettingsServicedeskTicketTypesConfigRoute.name,
	projectSettingsServicedeskUnassignedTicketTypesConfigRoute.name,
	servicedeskWorkflowConfigRoute.name,
	projectSettingsServicedeskIssuetypesRoute.name,
	projectSettingsServicedeskChannelsPortalRoute.name,
	projectSettingsServicedeskAutomationRoute.name,
	servicedeskSlaSettingsRoute.name,
	projectSettingsServicedeskInternalNotificationsNextGenRoute.name,
	landingPageRoute.name,
	browseConversationsRoute.name,
	browseIntentsRoute.name,
	browseStandardFlowsRoute.name,
	virtualAgentSettingsRoute.name,
	projectSettingsServicedeskLiveChatRoute.name,
	projectSettingsServicedeskProactiveSupportRoute.name,
	projectSettingsServicedeskProactiveSupportSensorDetailsRoute.name,
]);

// TODO move routes to routes when cleaning up jsm_manage_queues_in_space_settings
const routesWithManageQueuesRoute = new Set(routes);
routesWithManageQueuesRoute
	.add(servicedeskQueuesManageViewRoute.name)
	.add(servicedeskPracticeManageViewRoute.name);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName = routeContext.route.name;

	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;

	switch (routeName) {
		// Access Menu
		case 'legacy-project-settings-people':
		case projectSettingsServicedeskAccessRoute.name:
		case projectSettingsServicedeskCustomerPermissionsRoute.name:
		case projectSettingsServicedeskChannelsPermissionsNextGenRoute.name:
		case 'legacy-project-settings-permissions':
		case 'legacy-project-settings-issue-security':
			path.push(MENU_ID_SD_SETTINGS_ACCESS);
			break;

		// Request Management -> Request types menu
		case projectSettingsServicedeskItsmTicketTypesConfigRoute.name:
		case projectSettingsServicedeskUnassignedTicketTypesConfigRoute.name:
			path.push(
				MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT,
				MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES,
			);
			break;

		// Request Management -> Queues menu
		case servicedeskQueuesManageViewRoute.name:
		case servicedeskPracticeManageViewRoute.name:
			path.push(MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT, MENU_ID_SD_SETTINGS_QUEUES);
			break;

		// Request Mangagement (case-notes behind FG)
		case projectSettingsServicedeskCaseNotesEditRoute.name: // Case note edit
		case projectSettingsServicedeskCaseNotesRoute.name: // Case notes
			if (fg('jsm-case-management-settings')) {
				path.push(MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT);
				break;
			}
			break;

		// Request Management
		case projectSettingsServicedeskTicketTypesConfigRoute.name: // RTs
		case projectSettingsServicedeskProformaProjectFormsRoute.name: // Forms
		case 'legacy-project-settings-workflows': // Workflows
		case servicedeskWorkflowConfigRoute.name: // Workflows
		case 'legacy-project-settings-workflows-associate': // Workflows
		case 'servicedesk-sla-settings': // SLAs
		case servicedeskSlaSettingsRoute.name: // SLAs
		case projectSettingsServicedeskFeedbackRoute.name: // CSA
		case 'legacy-project-settings-issue-types': // Issue types
		case projectSettingsServicedeskIssuetypesRoute.name:
		case 'legacy-project-settings-fields': // Fields
		case projectSettingsServicedeskFieldsRoute.name:
		case projectSettingsServicedeskPoliciesRoute.name:
		case 'legacy-project-settings-screens':
			path.push(MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT);
			break;

		// Workforce Optimization
		case projectSettingsServicedeskWorkforceRoute.name:
		case projectSettingsServicedeskWorkforceOptimizationRoute.name:
			path.push(MENU_ID_SD_SETTINGS_WORKFORCE_OPTIMIZATION);
			break;

		// Automation
		case 'project-settings-automation':
		case projectSettingsServicedeskAutomationSummaryRoute.name:
			path.push(MENU_ID_SD_SETTINGS_AUTOMATION);
			break;

		// Channels and self-service
		case projectSettingsServicedeskPortalSettingsRoute.name:
		case projectSettingsServicedeskChannelsPortalRoute.name:
		case projectSettingsServicedeskEmailRoute.name:
		case projectSettingsServicedeskLiveChatRoute.name:
		case projectSettingsServicedeskChatRoute.name:
		case projectSettingsServicedeskWidgetRoute.name:
		case projectSettingsServicedeskKbRoute.name:
		case projectSettingsServicedeskExternalLinksRoute.name:
		case projectSettingsServicedeskChannelsChatRoute.name:
		case projectSettingsServicedeskChannelsWidgetRoute.name:
		case virtualAgentSettingsRoute.name:
		case landingPageRoute.name:
		case browseConversationsRoute.name:
		case browseIntentsRoute.name:
		case browseStandardFlowsRoute.name:
			path.push(MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE);
			break;

		// Operations
		case projectSettingsServicedeskChangeManagementRoute.name:
		case projectSettingsServicedeskIncidentManagementRoute.name:
			path.push(MENU_ID_SD_SETTINGS_OPERATIONS);
			break;

		// Notifications
		case 'legacy-project-settings-notifications':
		case projectSettingsServicedeskCustomerNotificationsRoute.name:
		case projectSettingsServicedeskNotificationsInternalNotificationsRoute.name:
		case projectSettingsServicedeskNotificationsCustomerNotificationsRoute.name:
		case projectSettingsServicedeskNotificationsEmailRoute.name:
		case projectSettingsServicedeskNotificationsNotificationEmailRoute.name:
		case projectSettingsServicedeskInternalNotificationsNextGenRoute.name:
			path.push(MENU_ID_SD_SETTINGS_NOTIFICATIONS);
			break;

		// Apps
		case projectSettingsServicedeskAppsFieldsRoute.name:
		case 'project-settings-servicedesk-rovo-ops':
		case 'project-settings-servicedesk-rovo':
		case projectSettingsServicedeskAiAgentsRoute.name:
		case 'project-settings-servicedesk-employee-onboarding-configuration':
		case projectSettingServicedeskRovoServiceRoute.name:
		case projectSettingServicedeskRequestResolverRoute.name:
		case projectSettingServicedeskSelfServiceSetupRoute.name:
			// ADD rest of the apps here
			path.push(MENU_ID_SD_SETTINGS_APPS);
			break;

		default:
			break;
	}

	return path;
}

export const serviceManagementProjectSettingsConverter: {
	readonly routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = {
	get routes(): Set<RouteName> {
		return fg('jsm_manage_queues_in_space_settings') ? routesWithManageQueuesRoute : routes;
	},
	convert,
	convertNew,
};
